/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { BodyInfo } from 'client-code/body-info-service';
import { IBodyInfoServiceRepository } from '../interfaces/IBodyInfoServiceRepository';
import { BodyInfoServiceRepositoryImpl } from '../impls/BodyInfoServiceRepositoryImpl';
import { TServicesParams } from '../types/TServicesParams';

export class BodyInfoService implements IBodyInfoServiceRepository {
    private oBodyInfoServiceRepository: BodyInfoServiceRepositoryImpl;

    constructor(params: TServicesParams) {
        this.oBodyInfoServiceRepository = new BodyInfoServiceRepositoryImpl(params);
    }

    fetchBodyInfo(): BodyInfo {
        return this.oBodyInfoServiceRepository.fetchBodyInfo();
    }

    async fetchAndStoreBodyInfoData(): Promise<BodyInfo> {
        return this.oBodyInfoServiceRepository.fetchAndStoreBodyInfoData();
    }
}
